import React, { useEffect, useState } from 'react';
import API from './Api';
import { useNavigate } from 'react-router-dom';
import AOS from 'aos';

import '../css/aos.css'; 

// Assets
import bannerImg from '../assets/images/banner.jpg'; 
import leafImg from '../assets/images/leaf.png'; 
// import logoImg from '../assets/images/nav-logo.png'; 
import waveImg from '../assets/images/background-white-color.png'; 
import circleImg from '../assets/images/about-1.jpg';
import serviceImg from '../assets/images/services-bg.jpg';
import blogImg1 from '../assets/images/services-bg.jpg';
import blogImg2 from '../assets/images/blog-1.jpg';
import blogImg3 from '../assets/images/blog-2.jpg';
import blogImg4 from '../assets/images/blog-3.jpg';
import yogaImage from '../assets/images/section-4-bg.jpg'

import LoginForm from '../pages/Login'

const Home = () => {
  const navigate = useNavigate();
  const [selectedInfo, setSelectedInfo] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const [galleryImages, setGalleryImages] = useState([blogImg1, blogImg2, blogImg3, blogImg4]);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const res = await API.get(
          'get-content/Home Gallery/'
        );

        const baseUrl = process.env.REACT_APP_BACKEND_URL || 'http://103.172.92.148:8005';
        let fetchedImages = [];

        const defaultImages = [
          blogImg1,
          blogImg2,
          blogImg3,
          blogImg4
        ];


        for (let i = 1; i <= 4; i++) {
          const imagePath = res.data[`gallery_${i}`];

          if (imagePath) {
            const fullImageUrl = imagePath.startsWith('http')
              ? imagePath
              : `${baseUrl}${imagePath}`;

            fetchedImages.push(fullImageUrl);
          } else {
            fetchedImages.push(defaultImages[i - 1]);
          }
        }

        if (fetchedImages.length > 0) {
          setGalleryImages(fetchedImages);
        }
      } catch (err) {
        console.error('Gallery fetch failed:', err);

        setGalleryImages([
          blogImg1,
          blogImg2,
          blogImg3,
          blogImg4
        ]);
      }
    };

    fetchGallery(); // ✅ directly call kara

    AOS.init({
      duration: 1200,
      easing: 'ease-out-back',
      once: false,
      mirror: true,
      offset: 100
    });
    AOS.refreshHard();
    const handleScroll = () => {
      const navbar = document.getElementById("navbar");

      if (navbar) {
        if (window.scrollY > 50) {
          navbar.classList.add("sticky");
        } else {
          navbar.classList.remove("sticky");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);

  }, []);
  const circleData = [
    {
      id: 1,
      title: "Happiness Mentor",
      short: "The great saint Samarth Ramdas Swami teaches us to look within.",
      isExternal: false,
      full: `The great saint Samarth Ramdas Swami says "Jagi sarv sukhi asa kon aahe vichare mana tuchi shodhuni paahe".
      Meaning "not a single soul on this planet is happy in all aspects"...` 
    },
    {
      id: 2,
      title: "OUR STORY ",
      short: "THE GLOBAL SCHOOL OF HAPPINESS.",
      actionType: "Introduction",
      link: "/TGSH/org/intro"
      
    },
    {
      id: 3,
      title: "Holistic Growth",
      short: "Sansmruti Publication- Explore our books and releases.",
      link: "/TGSH/sansmruti", 
      isExternal: true,
    }
  ];

  return (
    <div className="relative overflow-x-hidden">
      
      {/* --- BANNER SECTION --- */}
      <section 
        className="relative
          min-h-[700px]
          lg:min-h-[850px]
          flex
          items-center
          bg-cover
          bg-center
          text-white
          overflow-hidden" 
        style={{ backgroundImage: `url(${bannerImg})` }}
      >
        <div className="absolute inset-0 bg-black/50 pointer-events-none"></div>
        
        <div className="container mx-auto px-6 lg:px-16 relative z-10"> 
          <div  data-aos-delay="200" className="max-w-5xl pt-12 lg:pt-0">
           
            
            <h1
              className="
                text-base
                sm:text-lg
                md:text-xl
                lg:text-2xl
                font-bold
                uppercase
                mb-6
                lg:mb-8
                leading-[1.8]
              "
            >
              <span className="block mb-4">सर्वे भवन्तु सुखिनः ।</span>
              <span className="block mb-4">सर्वे सन्तु निरामयाः ।</span>
              <span className="block mb-4">सर्वे भद्राणि पश्यन्तु ।</span>
              <span className="block">मा कश्चिद्दुःखभाग्भवेत् ॥</span>
            </h1>

            <p
              className="
                text-lg
                md:text-xl
                lg:text-2xl
                font-bold
                text-[#54a50f]
                mt-4
                lg:mt-6
                mb-4
                lg:mb-6
              "
            >
                ॐ शान्ति: ! शान्ति: ! शान्ति: ||
            </p>

            <h2 className=" text-3xl
            sm:text-4xl
            md:text-5xl
            lg:text-6xl
            font-bold
            text-white
            leading-tight
            mb-4">
              Develop Body, Mind and Spirit!
            </h2>

            <p className="text-lg
            md:text-xl
            lg:text-2xl
            font-semibold
            text-[#54a50f]
            mt-4
            mb-8">
              Are You Happy ?
            </p>


            <button
              onClick={() => navigate('/TGSH/login')}
              className="
                inline-flex
                items-center
                justify-center
                border-2
                border-white
                hover:bg-[#54a50f]
                text-white
                px-8
                lg:px-10
                py-3
                lg:py-4
                rounded-full
                uppercase
                font-bold
                text-sm
                lg:text-base
                transition-all
                shadow-xl
              "
            >
              Register Here
            </button>
          </div>
        </div>

        <div className="absolute
        bottom-0
        left-0
        w-full
        h-[70px]
        md:h-[90px]
        lg:h-[120px] z-20 bg-no-repeat bg-bottom pointer-events-none"
          style={{ backgroundImage: `url(${waveImg})`, backgroundSize: '100% auto' }}></div>
      </section>

      {/* --- CIRCLE SECTION --- */}
      <section className="py-24 bg-white text-center relative z-10">
        <div>
          <img src={leafImg} className="mx-auto mb-6 w-12" alt="leaf" />
          <h2 className="text-4xl font-serif text-[#333] mb-2">Meditation as a lifestyle, Body & Soul</h2>
        </div>

        <div className="container mx-auto px-6 mt-14 grid grid-cols-1 md:grid-cols-3 gap-12 relative z-20">
          {circleData.map((item) => (
            <div 
              key={item.id} 
              className="flex flex-col items-center" 
              
            >
              {/* (z-index cursor-pointer ) */}
              <div 
                onClick={() => {
                  console.log("Item clicked:", item.title); 
                  
                  if (item.actionType === "LOGIN") {
                    setShowLogin(true);
                  } 
                  
                  else if (item.actionType === "Introduction") {
                    navigate(item.link);
                  } 
                  else if (item.isExternal) {
                    navigate(item.link);
                  } 
                  else {
                    setSelectedInfo(item);
                  }
                }}
                className="w-[260px] h-[260px] rounded-full border-[12px] border-gray-100 flex items-center justify-center cursor-pointer transition-all duration-500 transform hover:scale-105 shadow-sm overflow-hidden relative z-30"
              >
                {/* pointer-events-none  */}
                <div 
                  className="w-full h-full flex flex-col items-center justify-center text-white p-8 relative pointer-events-none"
                  style={{ 
                    backgroundImage: `linear-gradient(rgba(84, 165, 15, 0.7), rgba(0,0,0,0.5)), url(${circleImg})`, 
                    backgroundSize: 'cover', 
                    backgroundPosition: 'center'
                  }}
                >
                  <h4 className="font-bold text-xl mb-4 uppercase italic text-center leading-tight">
                    {item.title}
                  </h4>
                  <p className="text-xs md:text-sm text-center">
                    {item.short}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      
      {showLogin && <LoginForm onClose={() => setShowLogin(false)} />}

      {/* <section className="bg-[#f4f4f4] overflow-hidden">
        <div className="flex flex-col md:flex-row min-h-[500px]">
          
          
          <div className="md:w-1/3 relative">
            <div className="absolute inset-0 bg-gradient-to-r from-green-500/20 to-orange-500/20 z-10"></div>
            <img 
              src={serviceImg} 
              alt="Yoga" 
              className="w-full h-full object-cover object-top" 
            />
          </div>

          
          <div className="md:w-2/3 py-16 px-10 md:px-20 bg-[#f4f4f4]">
            <h2 className="text-4xl font-serif font-bold mb-4">Yoga Is Good For Everyone!</h2>
            <p className="text-gray-600 mb-2">Good for all men, women and childrens</p>
            <p className="text-gray-500 mb-10 max-w-lg">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry, a galley of type and scrambled...
            </p>

            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6">
              {["Yoga Cures Cancer", "Yogs Makes You Young", "Get Fit and Well", "Yoga Is Great!"].map((item, i) => (
                <div key={i}>
                  <div className="flex items-center space-x-3 mb-2">
                    <img src={leafImg} className="w-4 h-4" alt="leaf" />
                    <span className="text-gray-800 font-medium">{item}</span>
                  </div>
                  <div className="h-[1px] w-full bg-gray-300"></div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section> */}

      {/* --- YOGA INFO SECTION --- */}
      <section className="bg-[#f5f5f5] overflow-hidden">
          <div className="grid md:grid-cols-12">

            <div className="md:col-span-3 relative">
              <img
                src={serviceImg}
                alt="Yoga"
                className="w-full h-full min-h-[700px] object-cover"
              />
            </div>

            <div className="md:col-span-9 py-16 px-10 md:px-16">

              <h2 className="text-5xl font-serif mb-3">
                Yoga Is Good For Everyone!
              </h2>

              <h3 className="text-xl text-gray-600 mb-4">
                Good for all men, women and childrens
              </h3>

              <p className="text-gray-500 max-w-3xl mb-10">
                The Global School Of Happiness helps individuals
                achieve holistic wellbeing through meditation,
                yoga and self-development.
              </p>

              <div className="grid md:grid-cols-2 gap-x-16 gap-y-6">
                {[
                  "Mudra Abhyas",
                  "Happiness Ambassador",
                  "Motivational Lecture",
                  "Happiness Index Corporate",
                  "Self and Public Speaking (Upcoming)",
                  "Shit Smart (Upcoming)",
                  "How to be Celebrity Author (Upcoming)"
                ].map((item, i) => (
                  <div
                    key={i}
                    className="flex items-center gap-3 border-b pb-3"
                  >
                    <img
                      src={leafImg}
                      alt=""
                      className="w-4 h-4"
                    />

                    <span>{item}</span>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </section>

      {/* --- GALLERY --- */}
      <section className="bg-black text-white py-12 md:py-20">

        <div className="grid grid-cols-1 lg:grid-cols-12">

          {/* Left Content */}
          <div className="lg:col-span-9 px-4 md:px-8 lg:px-12">

            <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold mb-3">
              Control, Body & Mind!
            </h2>

            <h3 className="text-[#e67e22] text-base md:text-xl mb-6 md:mb-12">
              Good for all men, women and childrens
            </h3>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-8 mb-8 md:mb-12">

              {galleryImages.slice(0, 4).map((img, i) => (
                <div
                  key={i}
                  className="overflow-hidden border border-white/20 h-[140px] md:h-[220px]"
                >
                  <img
                    src={img}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}

            </div>

            <div className="max-w-3xl text-gray-300 space-y-4 md:space-y-5 mb-8 md:mb-10">

              <p className="text-sm md:text-base">
                The Global School Of Happiness:
                Elevate Your Glow, Embrace Your Joy.
              </p>

              <p className="text-sm md:text-base">
                We bridge ancient yogic wisdom with modern life,
                helping individuals achieve physical vitality,
                emotional resilience and spiritual growth.
              </p>

            </div>

            <div className="flex flex-col sm:flex-row gap-4">

              <button
                onClick={() => navigate('/TGSH/gallery/dawadiCenter')}
                className="
                  border
                  border-white
                  px-6
                  md:px-8
                  py-3
                  uppercase
                  text-sm
                  font-semibold
                  hover:bg-white
                  hover:text-black
                  transition-all
                "
              >
                Gallery
              </button>

              <button
                onClick={() => navigate('/TGSH/login')}
                className="
                  border
                  border-[#d4af37]
                  text-[#d4af37]
                  px-6
                  md:px-8
                  py-3
                  uppercase
                  text-sm
                  font-semibold
                  hover:bg-[#d4af37]
                  hover:text-black
                  transition-all
                "
              >
                Book Now
              </button>

            </div>

          </div>

          {/* Right Image */}
          <div className="lg:col-span-3 mt-8 lg:mt-0">

            <img
              src={yogaImage}
              alt="Yoga"
              className="w-full h-[250px] md:h-[350px] lg:h-full object-cover"
            />

          </div>

        </div>

      </section>
      <section className="bg-white py-24">

        <div className="text-center mb-16">

          <img
            src={leafImg}
            alt=""
            className="mx-auto mb-4 w-10"
          />

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif px-4">
            Some useful Happiness Articles
          </h2>

          <p className="text-gray-500 mt-3">
            Good for all men, women and childrens
          </p>

        </div>

        <div className="container mx-auto px-6">

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">

            {[blogImg1, blogImg2, blogImg3, blogImg4].map((img, i) => (

              <div
                key={i}
                className="flex flex-col sm:flex-row gap-4 border-b pb-6"
              >

                <img
                  src={img}
                  alt=""
                  className="w-full sm:w-40 h-48 sm:h-28 object-cover rounded"
                />

                <div>
                  <h3 className="font-semibold text-lg">
                    The Global School Of Happiness
                  </h3>

                  <p className="text-sm text-gray-500 mt-2">
                    Discover happiness through yoga,
                    meditation and self-awareness.
                  </p>
                </div>

              </div>

            ))}

          </div>

        </div>

      </section>
      {/* --- MODAL --- */}
      {selectedInfo && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
          <div className="absolute inset-0" onClick={() => setSelectedInfo(null)}></div>
          <div className="bg-white p-8 md:p-12 rounded-3xl max-w-2xl w-full relative z-[1000]">
            <button onClick={() => setSelectedInfo(null)} className="absolute top-4 right-6 text-3xl">&times;</button>
            <h3 className="text-2xl font-bold text-[#54a50f] mb-6 uppercase border-b pb-4">{selectedInfo.title}</h3>
            <div className="max-h-[60vh] overflow-y-auto">
              <p className="text-gray-700 leading-relaxed whitespace-pre-line">{selectedInfo.full}</p>
            </div>
            <div className="mt-8 text-center">
              <button onClick={() => setSelectedInfo(null)} className="bg-[#54a50f] text-white px-10 py-3 rounded-full font-bold uppercase">Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;